import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de SendGrid (Twilio) -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas sobre el texto real de pdfjs. Obligatorios (throw): folio, monto.
export const parsearSendgridDesdeTexto = (texto) => {
  // folio: tras "Invoice Number:" -> "INV19345039". Obligatorio.
  const mFolio = texto.match(/Invoice Number:\s*(\S+)/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura SendGrid (falta Invoice Number)");
  const folio = mFolio[1];

  // monto: "SubTotal  $19.95" -> 19.95. NUNCA "Balance Due" ni las lineas $0.00. Obligatorio.
  const mMonto = texto.match(/sub\s?total\s*\$\s*([\d,]+\.\d{2})/i);
  if (!mMonto) throw new Error("No se pudo leer el SubTotal de la factura SendGrid");
  const monto = Number(mMonto[1].replace(/,/g, ""));

  // fecha: tras "Invoice Date:" -> "01-Jul-2026" (DD-Mon-YYYY). Best-effort.
  const mFecha = texto.match(/Invoice Date:\s*(\d{1,2}-[A-Za-z]{3,}-\d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: la linea de charge que NO es Overage -> "Essentials 50K" (Plan + <n>K). Best-effort.
  const mConcepto = texto.match(/\b([A-Z][a-z]+\s+\d+K)\b/);
  const concepto = mConcepto ? mConcepto[1].trim() : "";

  // periodo: SIEMPRE derivado de `fecha` (regla sistemica) -> 2026-07-01 desde fecha 2026-07-01.
  // Ya NO se extrae del service period.
  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades: null };
};
